import React from 'react';
import PropTypes from 'prop-types';
import Routes from 'apps/portal/routes.erb';
import LayoutHeader from 'shared/layout-header';
import AuthLayout from 'apps/portal/layouts/auth';
import PasswordChangeFormContainer from './components/password-change-form/container';

const propTypes = {
  resetPasswordToken: PropTypes.string.isRequired,
};

export default function PortalPasswordChange({ resetPasswordToken }) {
  return (
    <AuthLayout
      headerButtons={(
        <LayoutHeader.Button
          href={Routes.new_identity_session_path()}
          theme="text"
        >
          Sign In
        </LayoutHeader.Button>
      )}
      title="Reset Password"
    >
      <PasswordChangeFormContainer resetPasswordToken={resetPasswordToken} />
    </AuthLayout>
  );
}
PortalPasswordChange.propTypes = propTypes;
